import { basicAccountInfo } from "api/basic_account_info";
import {  generic_get_api } from "api/generic_api";
import { Component } from "react";
import { Button } from 'react-bootstrap';
import { CODE_SEARCH } from 'utils/constants';
import { EventNames, trackEvent } from 'utils/mixpanel';
import { truncateText } from "utils/helpers";


class CodeSearch extends Component {

    constructor(props) {
        super(props);

        this.state = {
            search_string: null,
            search_result: [],
            search_answer: null,
            section_ids: [],
            working: false,
            formatted_address: null,
            use_district: null,
            special_use_districts: null,
        };
        this.resetAndSubmit = this.resetAndSubmit.bind(this);
    }

    resetAndSubmit() {
        this.setState({ 
            search_result: [],
            search_answer: null,
            formatted_address: null,
            use_district: null,
            special_use_districts: null,
        }, this.submitQuestion);
    }

    submitQuestion() {
        this.setState({working: true });


        generic_get_api(CODE_SEARCH, {search_string: this.state.search_string})
        .then(
            data => { 
                this.setState({
                    formatted_address: data.formatted_address,
                    use_district: data.use_district,
                    special_use_districts: data.special_use_districts,
                    search_result: data.search_result,
                    search_answer: data.search_answer,
                    section_ids: data.section_ids,
                    working: false,
                })
            }
        )
        .catch(error => {
        });
    }

    componentDidMount() {
        trackEvent(EventNames.PAGE_LOAD, {'data_1': 'code_search'});
        basicAccountInfo()
        .then(
            data => {
                this.setState({session_ok: true});
            }
        ).catch(error => {
            if (error?.name === 'LOGIN_ERROR') {
                this.props.history.push('/login');
            }
        });

    }

    render() {
        const {working, search_string, search_answer, formatted_address, use_district, special_use_districts} = this.state;
        
        const section_url = (section_id) => {
            return "/code/code_sections?section_id=" + section_id;
        }

        return(
            <div class="container  codeSearch ps-4">

                {this.state.session_ok && 
                    <>
                        <div class="row">
                            <div class="col-10"><input type="text" class="form-control" value={search_string} placeholder="Question" onChange={(e) => this.setState({search_string: e.target.value})}/> </div>
                            <div class="col-auto"><Button onClick={this.resetAndSubmit}>Submit</Button></div>
                        </div>
                    </>
                }

                {
                    working && 
                    <div class="container mt-5 text-center">
                        <span class="spinner-border" aria-hidden="true"></span>
                    </div>
                }
                { formatted_address && (use_district || special_use_districts) &&
                    <div class="container border rounded mt-4 p-3">
                        <div class="row">
                            <div class="col fw-semibold">{formatted_address}</div>
                        </div>
                        <div class="row mt-2">
                            <div class="col">
                                <div class="fw-semibold">Use district</div>
                                <div>{use_district}</div>
                            </div>
                            <div class="col">
                                {
                                    special_use_districts && 
                                    <>
                                        <div class="fw-semibold">Special use districts</div>
                                        <div>
                                            <ul>
                                                { special_use_districts.map(spud => {
                                                        return  <li className="mt-1">
                                                                    {spud}
                                                                </li>
                                                            
                                                    })
                                                }
                                            </ul>
                                        </div>
                                    </>
                                }
                                
                            </div>
                        </div>
                    </div>

                }
                { search_answer && 
                    <div class="container border rounded mt-4">
                        <div class="row">
                            <div class="col">
                                <ul>
                                    { search_answer.paragraphs.map(paragraph => {
                                            return  <li className="mt-2">
                                                        <span >{paragraph.text} <span className="fw-semibold"><small><a target="_blank" href={section_url(paragraph.section_number)}>(SEC. {paragraph.section_number}{paragraph.subsection})</a></small></span></span>
                                                    </li>
                                                
                                        })
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                }
                
                {/* {  
                    search_answer &&
                    <div class="row mt-5 mb-3">
                        <div class="col-12"><i class="fa-solid fa-wand-magic-sparkles"></i>&nbsp;AI Overview</div>
                        <div class="col mt-3">
                            <div dangerouslySetInnerHTML={{__html: search_answer}}/>
                        </div>
                    </div>

                } */}
                {/* <>
                    <div class="row"><div class="col"><hr></hr></div></div>
                    <div class="container">
                        <div class="row">
                        {
                            section_ids.map(section => {
                                return  <div class="col">{section}</div>
                            })
                        }
                        </div>
                    </div>
                </> */}

               
               
            </div>
        )
    }
}

export default CodeSearch;